<template>
  <section class="flight">
    <drivers-header title="Рейс" back="/flights-mobile" />
    <div v-if="flightLoaded" v-loading="isLoading" class="driver">
      <div class="driver__title">Информация о рейсе</div>
      <flight-status :status="flight.status" class="flight__status" />
      <div class="flight__info">
        <div class="flight__info-question">Дата погрузки</div>
        <div class="flight__info-answer">{{ formattedDate }}</div>
      </div>
      <div class="flight__info">
        <div class="flight__info-question">Тип перевозки</div>
        <div class="flight__info-answer">{{ flightType }}</div>
      </div>
      <div class="flight__info">
        <div class="flight__info-question">Груз</div>
        <div class="flight__info-answer mod-freight">{{ freight }}</div>
      </div>
      <div class="flight__info">
        <div class="flight__info-question">Цена</div>
        <div class="flight__info-answer">
          <span v-if="flight.type_code !== 'harvest_or_delivery'">{{ flightPrice }}&nbsp;₽/кг</span>
          <div v-else class="flex-v-center">
            <span class="single-price">{{ flightDeliveryPrice }}&nbsp;₽/кг&nbsp;(П)</span>
            <span class="single-price">{{ flightHarvestPrice }}&nbsp;₽/кг&nbsp;(У)</span>
          </div>
        </div>
      </div>
      <div class="flight__info">
        <div class="flight__info-question">Расстояние</div>
        <div class="flight__info-answer">{{ flight.distance }}&nbsp;км</div>
      </div>
      <div class="route flex-v-center first">
        <div class="arrow" />
        <div>{{ loadAddress }}</div>
      </div>
      <div class="route flex-v-center last">
        <div class="circle" />
        <div>{{ unloadAddress }}</div>
      </div>
      <div class="flight__info">
        <div class="flight__info-question">Авто</div>
        <div class="flight__info-answer mod-driver">
          <div :class="truckAdded ? 'small-accept' : 'small-waiting'" />
          <div>{{ truckNumber }}</div>
        </div>
      </div>
      <div v-if="trailorAdded" class="flight__info">
        <div class="flight__info-question">Прицеп</div>
        <div class="flight__info-answer mod-driver">
          <div class="small-accept" />
          <div>{{ flight.state_numbers_trailer }}</div>
        </div>
      </div>
      <div class="flight__info">
        <div class="flight__info-question">Водитель</div>
        <div class="flight__info-answer mod-driver">
          <div :class="driverAdded ? 'small-accept' : 'small-waiting'" />
          <div>{{ driverFio }}</div>
        </div>
      </div>
      <div class="flight__subtitle">Дополнительная информация</div>
      <div class="flight__info">
        <div class="flight__info-question">Способ погрузки</div>
        <div class="flight__info-answer">{{ flight.load_type_name }}</div>
      </div>
      <div class="flight__info">
        <div class="flight__info-question">Грузоподъемность весов</div>
        <div class="flight__info-answer">{{ flight.lifting_capacity }}&nbsp;т</div>
      </div>
      <div class="flight__info">
        <div class="flight__info-question">Грузим тралы</div>
        <div class="flight__info-answer">{{ flight.is_trawl ? 'Да' : 'Нет' }}</div>
      </div>
      <div v-if="showPrivateComment" class="flight__info">
        <div class="flight__info-question">Ответственный</div>
        <div class="flight__info-answer mod-dispatcher">
          <div>{{ responsiblePerson.person }}</div>
          <a :href="`tel:${responsiblePerson.link}`" class="phone">{{ responsiblePerson.phone }}</a>
        </div>
      </div>
      <div v-if="hasComment">
        <div class="flight__subtitle mod-comment">Комментарий:</div>
        <div class="flight__comment">{{ flight.comment }}</div>
      </div>
    </div>
    <div v-if="networkError" class="flight__error">
      <div class="flight__error-text">Произошел технический сбой. Вернитесь на страницу рейсов и повторите попытку</div>
      <new-button
        title="Вернуться к рейсам"
        type="primary"
        width="fullWidth"
        @button-clicked="$router.push('/flights-mobile')"
      />
    </div>
  </section>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { mapGetters } from 'vuex'
import { typeCodes } from '@/datas/consts'
import DriversHeader from '@/components/Drivers/DriversHeader/DriversHeader'
import FlightStatus from '@/views/FlightsMobile/components/FlightStatus'
import FlightsMixin from '@/views/FlightsMobile/FlightsMixin'
import NewButton from '@/components/Drivers/NewButton/NewButton'

const Responses = RepositoryFactory.get('responses')

export default {
  name: 'FlightMobile',
  components: {
    DriversHeader,
    FlightStatus,
    NewButton,
  },
  mixins: [FlightsMixin],
  data() {
    return {
      isLoading: true,
      networkError: false,
      flight: {},
    }
  },
  computed: {
    ...mapGetters({
      getLibObj: 'libs/getLibObj',
    }),
    flightLoaded() {
      return !_.isEmpty(this.flight)
    },
    freight() {
      return this.getLibObj('freightTypes')[this.flight.freight_id]
    },
    flightType() {
      if (_.isEmpty(this.flight)) {
        return ''
      }

      let type = typeCodes.find(item => item.label === this.flight.type_code)

      return type.full ? type.full : type.title
    },
    trailorAdded() {
      return (
        this.flight &&
        this.flight.state_numbers_trailer &&
        this.flight.state_numbers_trailer.length
      )
    },
    driverAdded() {
      return this.flight.driver_fio && this.flight.driver_fio.length
    },
    driverFio() {
      return this.flight.driver_fio && this.flight.driver_fio.length
        ? this.flight.driver_fio
        : 'Не назначено'
    },
    hasComment() {
      return this.flight.comment && this.flight.comment.length
    },
    showPrivateComment() {
      return (
        this.flight.status === 'accepted' &&
        this.flight.private_comment &&
        this.flight.private_comment.length
      )
    },
    responsiblePerson() {
      if (this.showPrivateComment) {
        let phone = this.flight.private_comment.match(/[\d\+][\d\s-\(\)]+/)[0]
        let person = this.flight.private_comment.replace(phone, '')
        let link = '+' + phone.replace(/[\+\(\)-\s]/g, '')

        return { phone, person, link }
      }

      return null
    },
  },
  async created() {
    const params = `item_type=${this.$route.params.type}&item_id=${this.$route.params.id}`

    try {
      let { data } = await Responses.getResponseOrRequest(params)
      this.flight = data
    } catch (e) {
      this.networkError = true
    } finally {
      this.isLoading = false
    }
  },
}
</script>

<style lang="sass" scoped>
@import "@/assets/styles/driver-styles.sass"
.flight
  &__status
    width: fit-content
    margin-top: 1.4rem
    margin-bottom: 3.2rem
  &__info
    display: flex
    justify-content: space-between
    padding: 1.6rem 0
    font-weight: 400
    font-size: 1.6rem
    line-height: 2rem
    border-top: 1px solid #EDEDED
    &.mod-bottom
      border-bottom: 1px solid #EDEDED

    &-question
      color: #747474
    &-answer
      color: #181818
      .single-price
        margin-left: 1.2rem
      &.mod-driver
        display: flex
        justify-content: flex-end
        align-items: center
        max-width: 75%
        text-align: end
      &.mod-dispatcher
        display: flex
        flex-direction: column
        align-items: flex-end
        .phone
          margin-top: 0.4rem
          font-weight: 700
          color: $mainColor
      &.mod-freight
        max-width: 50%
        text-align: end

  .route
    font-weight: 400
    font-size: 1.6rem
    line-height: 2rem
    color: #181818
    &.first
      margin-bottom: 0.8rem
    &.last
      margin-bottom: 1.6rem

  .arrow
    flex-shrink: 0
    width: 1.6rem
    height: 1.6rem
    margin-right: 0.4rem
    background: url('~@/assets/img/new-bid-arrow.svg')
    background-size: cover
  .circle
    flex-shrink: 0
    width: 1.6rem
    height: 1.6rem
    margin-right: 0.4rem
    background: url('~@/assets/img/new-circle.svg')
    background-size: cover
  .small-waiting
    flex-shrink: 0
    width: 1.6rem
    height: 1.6rem
    margin-top: 1px
    margin-right: 0.4rem
    background: url('~@/assets/img/new-waiting-small.svg')
    background-size: cover
  .small-accept
    flex-shrink: 0
    width: 1.6rem
    height: 1.6rem
    margin-top: 1px
    margin-right: 0.4rem
    background: url('~@/assets/img/new-accept-small.svg')
    background-size: cover

  &__subtitle
    padding: 3.2rem 0 2rem
    font-weight: 700
    font-size: 1.8rem
    line-height: 2.4rem
    border-top: 1px solid #EDEDED
    &.mod-comment
      padding-bottom: .8rem

  &__comment
    font-weight: 400
    font-size: 1.4rem
    line-height: 1.8rem
    color: #747474

  &__error
    margin-top: 12rem
    padding: 0 1.6rem
    font-weight: 700
    font-size: 1.8rem
    line-height: 2.4rem
    color: #181818
    &-text
      width: 70%
      margin: 0 auto 4rem
      text-align: center
</style>
